export default __webpack_public_path__ + "static/media/Button_carousel_left.f670a9a7.webp";